module.exports = "<!-- Page Body -->\r\n<div class=\"page-body landing_pages driversClub_landing\">\r\n    <!-- Your Content Goes Here -->\r\n    <div class=\"row\">\r\n        <!--<iframe width=\"100%\" height=\"700px\" src=\"http://api.driversclubonline.co.uk?site=myfleethub\" frameborder=\"0\"></iframe>-->\r\n        <iframe width=\"100%\" height=\"700px\" src=\"https://pumplocator.fuelcardservices.com/?sitecode=FDC\" frameborder=\"0\"></iframe>\r\n    </div>\r\n</div>\r\n<!-- /Page Body -->\r\n<div mft-footer></div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pumplocator/pumplocator.component.html
// module id = ./src/app/pumplocator/pumplocator.component.html
// module chunks = main